import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Loading from '../utility/Loading';

export default class AdminPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  render() {
    if (this.state.isLoading) {
      return <Loading height="100vh" />;
    }

    return (
      <div className="admin-page">
        <div>
          <h1>Admin Panel</h1>
        </div>
        <div className="links" data-cy="admin-links">
          <Link to="admin/manage-users">Manage Users</Link>
        </div>
      </div>
    );
  }
}
